export const LEGAL_LINKS: Record<string, { terms: string; privacy: string }> = {
  es: {
    terms: 'https://factorial.es/terminos-condiciones',
    privacy: 'https://factorial.es/privacidad',
  },
  fr: {
    terms: 'https://factorial.fr/conditions-utilisation',
    privacy: 'https://factorial.fr/confidentialite',
  },
  de: {
    terms: 'https://factorialhr.de/allgemeine-geschaeftsbedingungen',
    privacy: 'https://factorialhr.de/datenschutz',
  },
  'en-GB': {
    terms: 'https://factorialhr.co.uk/terms-of-use',
    privacy: 'https://factorialhr.co.uk/privacy-policy',
  },
  it: {
    terms: 'https://factorial.it/termini-d-uso',
    privacy: 'https://factorial.it/privacy',
  },
  pt: {
    terms: 'https://factorialhr.pt/termos-de-utilizacao',
    privacy: 'https://factorialhr.pt/politica-de-privacidade',
  },
  'pt-BR': {
    terms: 'https://factorialhr.com.br/termos-condicoes',
    privacy: 'https://factorialhr.com.br/politica-privacidade',
  },
  en: {
    terms: 'https://factorialhr.com/terms-of-use',
    privacy: 'https://factorialhr.com/privacy',
  },
  'en-US': {
    terms: 'https://factorialhr.com/terms-of-use',
    privacy: 'https://factorialhr.com/privacy',
  },
}
